'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:autoLock');
}

var _invoke = require('../invoke');
var env = require('../invoke/env');
var versionCompare = require('../invoke/version-compare');

/**
 * 不允许自动锁屏
 *
 * 支持版本
 * + iHotel/6.5+
 *
 * @memberof ui
 * @static
 * @name autoLock
 * @param {Boolean} enable true表示禁止自动锁屏
 * @return {Undefined}
 * @example
 *  hbnb.ui.autoLock();
 */
module.exports = function(enable) {
    if (process.env.NODE_ENV !== 'production') {
        debug('enable', enable);
    }

    if (versionCompare(env.appVersion, '6.5') >= 0) {
        _invoke('ui', 'auto_lock', {
            enable: enable
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/ui/auto-lock.js
// module id = 284
// module chunks = 0